import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, FormControlLabel } from '@mui/material';
import styles from '../index.module.scss';
import CheckboxField from '../../../../../../../Inputs/CheckboxField';
import useIntakeBlockToggle, { intakeBlocksEnum } from '../../../../hooks/useIntakeBlockToggle';
import useIntakeData from '../../../../../../../../services/intakeDataService';

const AssignPatientBlock = () => {
  const { data } = useIntakeData();
  const { control, getValues } = useFormContext();
  const { isOn, isRequired } = useIntakeBlockToggle();

  if (!data?.isAllowedToTreat || !isOn(intakeBlocksEnum.assignpt)) {
    return null;
  }

  return (
    <FormControl>
      <Controller
        render={({ field }) => (
          <FormControlLabel
            control={
              <CheckboxField
                {...field}
                defaultChecked={getValues('assignPt') ?? true}
                classes={{
                  root: styles.checkbox,
                  checked: styles.checked,
                }}
              />
            }
            label={
              <div>
                Assign this patient to me
                {isRequired(intakeBlocksEnum.assignpt) ? (
                  <span className={styles.required}>*</span>
                ) : null}
              </div>
            }
            className={styles.checkboxLabel}
          />
        )}
        name="assignPt"
        defaultValue={getValues('assignPt') ?? true}
        control={control}
      />
    </FormControl>
  );
};
export default AssignPatientBlock;
